import React from 'react';

import { DialogContext } from '@cvt/contexts';

import { Authenticated } from '@modules/Auth/components';
import { ResetAccountTrigger } from '@modules/Users/components/ResetAccountTrigger';
import { ResetAccountDialog } from '@modules/Users/dialogs/ResetAccount';
import { InviteTeamMemberDialog } from '@modules/Users/dialogs/InviteTeamMember';
import { SupportContactDialog } from '@modules/Users/dialogs/SupportContact';

export const Dialogs = () => {
  const { openedDialogs, closeDialog } = React.useContext(DialogContext);
  return (
    <React.Fragment>
      <Authenticated>
        <InviteTeamMemberDialog open={!!openedDialogs['inviteTeamMember']} onClose={() => closeDialog('inviteTeamMember')} />
        <ResetAccountDialog open={!!openedDialogs['resetAccount']} onClose={() => closeDialog('resetAccount')} />
        <ResetAccountTrigger />
        <SupportContactDialog open={!!openedDialogs['supportContact']} onClose={() => closeDialog('supportContact')} />
      </Authenticated>
    </React.Fragment>
  );
};
